<template>
  <div class="game_banner d-flex-column align-start t-white pad-24-0">
    <OnlineBooster :fake_counter="fake_counter" />
    <h1 class="title-h2 t-white font-family-1 f-w-600">
      {{ $t(`${currentGameSlug}.title`) }}
    </h1>
    <div class="regular-l t-light font-family-2 description">
      {{ $t(`${currentGameSlug}.description_1`) }}
      <h2 class="inline regular-l t-light font-family-2">
        {{ $t(`${currentGameSlug}.description_2`) }}
      </h2>
      {{ $t(`${currentGameSlug}.description_3`) }}
    </div>
  </div>
</template>

<script setup>
import OnlineBooster from "../common/OnlineBooster.vue";
const { currentGameSlug } = useGameComposable();

const props = defineProps({
  fake_counter: {
    default: false,
  },
});
</script>
